import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { CommonService } from '../common.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionDataService {

  constructor(private configServie: ConfigurationService) { }

  Upgrade(Type, central_User_ID, productName, TableRecordCnt, numberOfUsers, planId, pricingID,TaxYear) {
    debugger
    //this.getSubscrptionCheck(central_User_ID).subscribe((data) => {
      //var stringJson = JSON.stringify(data);
      //var stringObject = JSON.parse(stringJson);
      //var resp = JSON.parse(stringObject[0]);
      var sa = true;
      if (sa == true) {
        var CentralUserID = (central_User_ID).toString();
        var subscriptionURL = this.configServie.subscriptionURL;
        // "http://192.168.0.44:3036";     
        var encryptedData = CryptoJS.AES.encrypt(productName.toString(), "My Secret Passphrase");
        var productId = encryptedData.toString();
        productId = productId.split('+').join('vkanslab');

        var encryptedData1 = CryptoJS.AES.encrypt(CentralUserID, "My Secret Passphrase");
        var centralUserId = encryptedData1.toString();
        centralUserId = centralUserId.split('+').join('vkanslab');


        if (Type == 'Upgrade') {
          var encryptedData2 = CryptoJS.AES.encrypt("Upgrade", "My Secret Passphrase");
          var name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Renew') {
          var encryptedData2 = CryptoJS.AES.encrypt("Renew", "My Secret Passphrase");
          var name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Trial2Paid') {
          var encryptedData2 = CryptoJS.AES.encrypt("Trial2Paid", "My Secret Passphrase");
          var name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        }

        var encryptedData3 = CryptoJS.AES.encrypt(TableRecordCnt + "", "My Secret Passphrase");
        var numberOfTaxpayers = encryptedData3.toString();
        numberOfTaxpayers = numberOfTaxpayers.split('+').join('vkanslab');


        var encryptedData4 = CryptoJS.AES.encrypt("Annually", "My Secret Passphrase");
        var subType = encryptedData4.toString();
        subType = subType.split('+').join('vkanslab');

        //  this.TableRecordCnt = localStorage.getItem("TableRecordCnt");
        var numOfUsers = numberOfUsers + "";
        var encryptedData5 = CryptoJS.AES.encrypt(numOfUsers, "My Secret Passphrase");
        var _numberOfUsers = encryptedData5.toString();
        _numberOfUsers = _numberOfUsers.split('+').join('vkanslab');


        //upgrade from users
        if (Type == 'Upgrade' || Type == 'Renew' || Type == 'Trial2Paid') {
          var encryptedData6 = CryptoJS.AES.encrypt("FromCompanies", "My Secret Passphrase");
          var StatusFrom = encryptedData6.toString();
          StatusFrom = StatusFrom.split('+').join('vkanslab');
          var encryptedDataTax = CryptoJS.AES.encrypt(TaxYear, "My Secret Passphrase");
          var TaxYear = encryptedDataTax.toString();
          TaxYear = TaxYear.split('+').join('vkanslab');
          var encryptedDataPlanId = CryptoJS.AES.encrypt(planId + "", "My Secret Passphrase");
          var PlanId = encryptedDataPlanId.toString();
          PlanId = PlanId.split('+').join('vkanslab');
          var encryptedDataPricingID = CryptoJS.AES.encrypt(pricingID + "", "My Secret Passphrase");
          var PricingID = encryptedDataPricingID.toString();
          PricingID = PricingID.split('+').join('vkanslab');
          //var encryptedDataproductId = CryptoJS.AES.encrypt(this.productName + "", "My Secret Passphrase");
          //var productId = encryptedDataproductId.toString();
          // var productId = this.productName;

        }
        //this.commonService.IsImportEnable(false)
        var URl = '';
        if (Type == 'Renew' || Type == 'Upgrade' || Type == 'Trial2Paid') {
          URl = subscriptionURL + "/CustomerPlans?ProductName=" + productId + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfTaxpayers + "&subType=" + subType + "&RegUsers=" + _numberOfUsers + "&StatusFrom=" + StatusFrom + "&TaxYear=" + TaxYear + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        else {
          URl = subscriptionURL + "/CustomerPlans?ProductName=" + productId + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfTaxpayers + "&subType=" + subType + "&RegUsers=" + _numberOfUsers + "&StatusFrom=" + StatusFrom;
        }
        window.open(URl, '_self');
      }
      else {
        Swal.fire('', "This software license is deactivated .please contact Andica Sales.");
        return;
      }
    //})
  }
}
